import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { Button, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Card from "src/components/Cards/Basic";
import FormCheckbox from "src/components/Forms/FormCheckbox";
import FormSelectBox from "src/components/Forms/FormSelectBox";
import {
  showErrorToast,
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import axios from "src/config/axios";

const CHECKIN_LOCATION_OPTIONS = [
  { value: "entry_column", name: "Einfahrtssäule" },
  { value: "ticketvendingmachine", name: "Automat" },
];

const CHECKOUT_LOCATION_OPTIONS = [
  { value: "exit_column", name: "Ausfahrtssäule" },
  { value: "ticketvendingmachine", name: "Automat" },
];

const TicketVendingMachineSettingsPage = () => {
  const { id } = useParams();
  const [ticketVendingMachineSetting, setTicketVendingMachineSetting] =
    useState();

  useEffect(() => {
    loadTicketVendingMachineSetting();
  }, [id]);

  const loadTicketVendingMachineSetting = () => {
    axios
      .get(`/api/v1/admin/businesses/${id}/ticket_vending_machine_setting.json`)
      .then(({ data }) => {
        setTicketVendingMachineSetting(data);
      })
      .catch(() => showErrorToast());
  };

  const handleSubmit = (values, helpers) => {
    helpers.setSubmitting(true);
    axios
      .put(
        `/api/v1/admin/businesses/${id}/ticket_vending_machine_setting.json`,
        {
          ticket_vending_machine_setting: values,
        }
      )
      .then(({ data }) => {
        setTicketVendingMachineSetting(data);
        showSuccessToast();
      })
      .catch((error) => {
        helpers.setErrors(error.response.data);
        showValidationErrorToast(error);
      })
      .finally(() => {
        helpers.setSubmitting(false);
      });
  };

  return (
    <Card title="Automat Einstellungen">
      {!ticketVendingMachineSetting ? (
        <Spinner
          className={"d-block mx-auto"}
          animation="border"
          variant="primary"
        />
      ) : (
        <Formik
          initialValues={{
            cash_payment_enabled:
              ticketVendingMachineSetting.cash_payment_enabled,
            pos_payment_enabled:
              ticketVendingMachineSetting.pos_payment_enabled,
            viva_pos_enabled: ticketVendingMachineSetting.viva_pos_enabled,
            wc_wash_enabled: ticketVendingMachineSetting.wc_wash_enabled,
            hoppers_enabled: ticketVendingMachineSetting.hoppers_enabled,
            checkin_location: ticketVendingMachineSetting.checkin_location,
            checkout_location: ticketVendingMachineSetting.checkout_location,
          }}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, values }) => (
            <Form>
              <FormCheckbox
                name={"cash_payment_enabled"}
                label={"Barzahlung aktivieren"}
                hint={"Erlaubt Zahlungen mit Bargeld am Ticketautomaten."}
              />
              <FormCheckbox
                name={"pos_payment_enabled"}
                disabled={values.viva_pos_enabled}
                label={"POS Zahlung aktivieren"}
                hint={"Erlaubt Kartenzahlungen ueber das lokale POS Terminal."}
              />
              <FormCheckbox
                name={"viva_pos_enabled"}
                disabled={values.pos_payment_enabled}
                label={"Viva POS aktivieren"}
                hint={"Erlaubt Kartenzahlungen ueber Viva POS."}
              />
              <FormCheckbox
                name={"hoppers_enabled"}
                label={"Hopper aktivieren"}
                hint={"Aktiviert die Muenzausgabe am Ticketautomaten."}
              />
              {ticketVendingMachineSetting.configuration.addons
                .wc_wash_enabled && (
                <FormCheckbox
                  name={"wc_wash_enabled"}
                  label={"WC Wash aktivieren"}
                  hint={"Aktiviert WC Wash am Ticketautomaten."}
                />
              )}
              <FormSelectBox
                name={"checkin_location"}
                label={"Checkin Ort"}
                hint={"Legt fest, wo Gäste einchecken koennen."}
                options={CHECKIN_LOCATION_OPTIONS}
              />
              <FormSelectBox
                name={"checkout_location"}
                label={"Checkout Ort"}
                hint={"Legt fest, wo Gäste auschecken koennen."}
                options={CHECKOUT_LOCATION_OPTIONS}
              />

              <Button type={"submit"} disabled={isSubmitting}>
                Speichern
              </Button>
            </Form>
          )}
        </Formik>
      )}
    </Card>
  );
};

export default TicketVendingMachineSettingsPage;
